/* template

{
  image: '',
  name: '',
  cost: '',
  place: ``,
  location: ``,
  description: ``,
},

*/

const thriftEntries = [
  {
    image: '/assets/thrifted/double_collar_quarter_zip.webp',
    name: 'Double Collar Quarter Zip',
    cost: '7',
    place: `fundraising event on campus`,
    location: `Pittsburgh, PA`,
    description: `This is one of my favorite thrfit finds; I love how the collar color (ha!) contrasts with the black! It's also perfect for the cold because the double collar keeps my neck really warm and snuggly :-) I got this piece at a random second-hand clothes fundraising event I came across on campus after class one day, super glad I stopped by!

    P.S. pants are also thrifted (from Goodwill), they're SUCH GOOD KHAKIS! Obsessed with this outfit.
    
    P.P.S. Car's name is BenJeep; we rented it for a camping trip in October 2020.`,
  },
  {
    image: '/assets/thrifted/flowered_button_top.webp',
    name: 'Flowered Button Top',
    cost: '8',
    place: `Avalon Exchange`,
    location: `Pittsburgh, PA`,
    description: `I got this shirt from Avalon the first time I thrifted there in October 2017. It's been a solid semi-casual top, worn during various presentations.

    Photo taken in April 2020, in front of the house I lived in my junior year. After COVID-19 hit, I decided to graduate a year early so this was my "graduation photoshoot" :'c`,
  },
  {
    image: '/assets/thrifted/green_flowy_pants.webp',
    name: 'Green Flowy Pants',
    cost: '5',
    place: `Goodwill`,
    location: `Pittsburgh, PA`,
    description: `These pants are basically pajama pants that are socially-acceptable to wear outsie. They're extremely comfortable, it's so freeeeing to wear them.

    Photo taken during spring break at Miami FL in March 2020, before we knew how serious COVID-19 was`,
  },
  {
    image: '/assets/thrifted/maroon_jumpsuit.webp',
    name: 'Maroon Jumpsuit',
    cost: "16",
    place: 'Avalon Exchange',
    location: 'Pittsburgh, PA',
    description: `I got this from Avalon at their semi-annual dollar sale, but as you can see, NOT for a dollar! I took my friend thrifting and promised that I wouldn't get anything for myself, but... I had been on the lookout for a jumpsuit AND my favorite color is maroon! The jumpsuit was hanging on top of a rack on the way to the "dollar section", so it really felt like ~destiny~... I know, I know, that's how they get you.. but I'm still very happy with this purchase!

    Photo taken during spring break at Puerto Rico, March 2019`,
  },
  {
    image: '/assets/thrifted/navy_dress_pants.webp',
    name: 'Navy Dress Pants',
    cost: "11",
    place: 'Goodwill',
    location: 'Sunnyvale, CA',
    description: `I bought this pair of pants in winter of my sophomore year, because I wanted to invest in pants that I could easily dress up and down. I ended up wearing this to Make the Magic, an annual fundraising gala for Camp Kesem (a non-profit that provides a free week of camp for kids whose parents have cancer)!

    Photo taken at Palo Alto CA, January 2020`,
  },
  {
    image: '/assets/thrifted/red_rain_jacket.webp',
    name: 'Red Rain Jacket',
    cost: "0",
    place: `"borrowed" from my mom's closet`,
    description: `One summer, I visited New York for two weeks and had only brought a thin rain jacket which my mom lent to me before the trip. One afternoon, we decided to take the ferry to New Jersey. Oh boy, was this a bad idea. We had gone to Carlo's Bake Shop and when we came out of the bakery, it was pouring. The box of pastries got soaked and even started to fall apart. .... and this was when I found out that the jacket wasn't actually a rain jacket.

    Photo taken at Hoboken NJ, July 2019`,
  },
  {
    image: '/assets/thrifted/striped_tie_top.webp',
    name: 'Striped Tie Top',
    cost: "5",
    place: 'from a girl in my dorm',
    location: 'Pittsburgh, PA',
    description: `I bought this shirt in spring of 2019 from a girl who posted on "For Sale @ CMU", a facebook group for CMU students. I also purchased the matching pants but they were too long so I tried to hem them... let's just say I've still never worn the bottom out :-)

    Photo taken while picnicing at Schenley Plaza, Pittsburgh PA, June 2019`,
  },
  {
    image: '/assets/thrifted/grandpa_sweater.webp',
    name: 'Grandpa Sweater',
    cost: "don't remember",
    place: 'probably Goodwill',
    description: `I LOVE this sweater, it is so thick and cozy! I always take it with me whenever i go hiking or camping-- one summer, even though I knew it would be humid outside, I wore this sweater to keep the mosquitos from biting me. It protected me... unlike the red "rain jacket".
    
    Photo taken at Salsa Night, at CMU's Cohon University Center, October 2019`,
  },
  {
    image: '/assets/thrifted/white_turtle_neck.webp',
    name: 'White Turtle Neck',
    cost: '0',
    place: "stolen from my brother's closet",
    description: `I have treasured this top since high school, when I raided my younger brother's closet for the first time. He never shops for himself so I'm not sure how/ where he obtained this shirt from, but I LOVE turtle necks so I have claimed it as my own. :-)
    
    Photo taken at SCOPE Art Exhibit in NYC, March 2018`
  },
];

export default thriftEntries;